
const SecondaryButton = (props) => {
    return (
        <button style={props.style} className={`${props.className} btn-blue-sm`} type={props.type} onClick={props.onClick} >{props.children}</button>
    )
}

export default SecondaryButton;